import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { PAGE_ROUTES } from '../../../../constants/pageRoutes';
import { ROLE_TYPE } from '../../../../constants/roles';
import { getUserProfileInfo } from '../../../user/actions';

const mapStateToProps = state => ({
  global: state.Global,
  user: state.User
});

class CompleteProfile extends Component {
  constructor(props) {
    super(props);

    this.onSkip = this.onSkip.bind(this);
    this.onUpdate = this.onUpdate.bind(this);
    this.getUpdateProfileLink = this.getUpdateProfileLink.bind(this);
  }

  componentWillMount() {
    let { history, global, dispatch } = this.props;

    if (!global.userId) {
      history.push(PAGE_ROUTES.LOGIN);
      return;
    }

    dispatch(getUserProfileInfo(global.userId));
  }

  onSkip = () => {
    const { history } = this.props;
    history.push(PAGE_ROUTES.DASHBOARD);
  }

  onUpdate = () => {
    const { history } = this.props;
    history.push(this.getUpdateProfileLink());
  }

  getUpdateProfileLink = () => {
    const { user } = this.props.user;
    if (!user)
      return PAGE_ROUTES.LOGIN;

    return user.userType === ROLE_TYPE.owner ? PAGE_ROUTES.OWNER_SIGN_UP_3 : PAGE_ROUTES.RENTER_SIGN_UP_3;
  }

  render() {
    return (
      <div className="main-container">
        <div className="main-wrapper">
          <div className="left-section">
            <div className="white-background">
              <div className="content-section" style={{ margin: '100px 0 50px 0' }}>
                <h1 className="title">Account Created!</h1>
                <p className="detail-text role-text" style={{ marginTop: '20px' }}>Welcome to CollegeWeekends!<br /><br />
                  Please set up your Profile by including a Profile picture and more information about yourself.</p>
                <div className="signin-page">
                  <form className="form-section">
                    <div className="combo-button">
                      <div className="back-button">
                        <button onClick={this.onSkip} className="btn dark">Skip</button>
                      </div>
                      <div className="signin-button">
                        <button onClick={this.onUpdate} className="btn primary">Complete Your Profile</button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div className="right-section">
            <div className="bg-image"></div>
          </div>
        </div>
      </div >
    );

  }
}

export default withRouter(connect(mapStateToProps)(CompleteProfile));
